const r = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info"
};
export {
  r as STATUS_COLOR
};
//# sourceMappingURL=status.es.js.map
